// src/config.js
const config = {
  API_BASE_URL: 'https://b61vwmkwo8.execute-api.us-east-2.amazonaws.com/dev',
  API_KEY: 'TyaJuLMQ5Ta29atKSlyuR3uFft2li29S4mOv846g', 
};

export default config;

